import * as types from './actionTypes';
import { postRequest, deleteRequest } from '../../lib/apiUtils';
import { clearRecipientSummaryCache } from '../../lib/recipientSummaryCache';

export function printChecks(printJobType, printerId, printDetails) {
    return async dispatch => {
        dispatch({ type: types.START_PRINT_CHECKS, printerId });
        
        const response = await postRequest(`/printJobs`, { printerId, printJobType, ...printDetails }, []);
        if (response.success && printJobType === 'applications') clearRecipientSummaryCache();

        if (printJobType === 'reprints') delete response.data;
        dispatch({ type: types.PRINT_CHECKS_COMPLETED, response });
    };
}

export function confirmChecksPrinted(printJobIds, isCancel) {
    return async dispatch => {
        dispatch({ type: types.START_CONFIRM_CHECKS_PRINTED });

        const response = await deleteRequest(`/printjobs`, { printJobIds, isCancel });
        
        dispatch({ type: types.CONFIRM_CHECKS_PRINTED, response });
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/CheckPrintingActions.js